<cc-top-bar [title]="('INTEGRATIONS.LIST.TITLE' | translate)"></cc-top-bar>
<section>
  <router-outlet></router-outlet>
</section>
